<div class="UpcomingWrapper">


    <div class="partTop">
        <div class="label">
            Pending Approvals
        </div>
    </div>

    <!-- <div class="title" *ngIf="authService.profile?.pendingBookings?.length">
        <div class="label">Pending Approvals</div>
    </div> -->
    <div class="title" *ngIf="authService.profile?.pendingBookings?.length == 0">
        <div class="label spaceBelow">No Pending Approvals</div>
    </div>
    <div class="list" *ngIf="authService.profile?.pendingBookings?.length">
        <app-booking-card [booking]="booking" (cancel)="onCancel($event)" [isCancellable]="true"
            *ngFor="let booking of authService.profile?.pendingBookings "></app-booking-card> 
    </div>



    <div class="partTop">
        <div class="label">
            Booked
        </div>
    </div>

    <!-- <div class="title" *ngIf="authService.profile?.approvedBookings?.length">
        <div class="label">Booked</div>
    </div> -->

    <div class="title" *ngIf="authService.profile?.approvedBookings?.length == 0">
        <div class="label">No Booked Movies</div>
    </div>
    <div class="list" *ngIf="authService.profile?.approvedBookings?.length">
        <app-booking-card [booking]="booking" (cancel)="onCancel($event)" [isCancellable]="true"
            *ngFor="let booking of authService.profile?.approvedBookings"></app-booking-card>
    </div>

    <div class="space"></div>

</div>

<app-cancel-booking-overlay *ngIf="isCancelOverlayOn" (onConfirm)="onCancelExecute()" (onClose)="closeOverlay()"></app-cancel-booking-overlay>